import { Component, inject, OnInit, OnDestroy, HostListener, AfterViewInit, ChangeDetectorRef } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { MatDialogModule } from '@angular/material/dialog';
import { DialogService } from '../services/dialog-service/dialog.service';
import { CanComponentDeactivate } from '../guards/unsaved-changes.guard';
import { UnsavedChangesTrackerService } from '../services/unsaved-changes/unsaved-changes-tracker.service';
import { UnsavedChangesHostHelper } from '../services/unsaved-changes/unsaved-changes-host.helper';
import { ClientSideRowModelModule, ColDef, GridReadyEvent, ModuleRegistry, PaginationChangedEvent, RowSelectionOptions } from 'ag-grid-community';
import { AgGridAngular } from 'ag-grid-angular';
import { AgGridModule } from 'ag-grid-angular';
import { MatIconModule } from '@angular/material/icon';
import { MatButtonModule } from '@angular/material/button';
import { DeviceService } from '../services/device-service/device.service';
import { CustomerService } from '../services/customer-service/customer.service';
import { CommonModule } from '@angular/common';
import { CellClickedEvent } from 'ag-grid-community';
import { Router, ActivatedRoute, RouterLink } from '@angular/router';
import { MatInputModule } from '@angular/material/input';
import moment from 'moment';
import { get } from 'lodash'; // for copy data cell value
import { FormsModule } from '@angular/forms';
import { ButtonCellRendererDeviceListComponent } from '../shared/components/button-cell-renderer/button-cell-renderer-device-list.component';
import { UpdateDeviceListComponent } from '../Dialogs/update-device-list/update-device-list.component';
import { BehaviorSubject, of } from 'rxjs';
import { concatMap, tap } from 'rxjs/operators';
import { ToastrService } from 'ngx-toastr';
import { HasPermissionDirective } from '../directives/has-permission.directive';
import { RbacService } from '../services/rbac/rbac.service';
import { RbacPermissions } from '../services/rbac/rbac-permissions';
import { AG_GRID_PAGE_SIZE_OPTIONS, AG_GRID_DEFAULT_PAGE_SIZE, AG_GRID_DEFAULT_ROW_HEIGHT_PX, AG_GRID_EMPTY_BODY_ROW_PX, AG_GRID_HEADER_AND_PAGING_PX, syncInfiniteRowModelPageSize } from '../shared/ag-grid/ag-grid-pagination.util';
import { withDateColumnLayout, createUtcDateFilterParams, formatUtcDateTimeCell, mapAgGridFilterToApi } from '../shared/ag-grid/ag-grid-date-column.util';
import { createAgGridSelectFloatingFilter } from '../shared/ag-grid/select-floating-filter';
import { AgGridCopyCellTooltipDirective } from '../shared/ag-grid/ag-grid-copy-cell-tooltip.directive';
import {
  CUSTOMER_DROPDOWN_SELECT_LABEL,
  getGroupDropdownEmptyLabel,
  hasConcreteCustomerSelected,
  isGroupDropdownDisabled,
} from '../services/group-dropdown.util';
ModuleRegistry.registerModules([ClientSideRowModelModule]);

/** Status enum floating filter — matches CommonService.deviceStatusOptions. */
const DeviceStatusFloatingFilter = createAgGridSelectFloatingFilter([
  { label: 'All', value: '' },
  { label: 'New', value: 'New' },
  { label: 'Provisioned', value: 'Provisioned' },
  { label: 'Provisioning - Error', value: 'Provisioning - Error' },
  { label: 'Installed', value: 'Installed' },
  { label: 'Installed - Error', value: 'Installed - Error' },
  { label: 'Installed - Incomplete', value: 'Installed - Incomplete' },
  { label: 'Reset', value: 'Reset' },
  { label: 'Deleted', value: 'Deleted' },
  { label: 'Uninstalled', value: 'Uninstalled' },
]);

@Component({
  selector: 'app-device-list',
  standalone: true,
  imports: [
    MatDialogModule,
    AgGridAngular,
    MatIconModule,
    MatButtonModule,
    AgGridModule,
    CommonModule,
    MatInputModule,
    RouterLink,
    FormsModule,
    HasPermissionDirective,
    AgGridCopyCellTooltipDirective,
  ],
  templateUrl: './device-list.component.html',
  styleUrl: './device-list.component.scss',
})
export class DeviceListComponent implements OnInit, AfterViewInit, OnDestroy, CanComponentDeactivate {
  private readonly cdr = inject(ChangeDetectorRef);
  deviceId: any;
  customerList: any[] = [];
  groups: any[] = [];
  selectedCustomer: string = 'All';
  selectedGroup: string = '';
  /** False while groups are loading for the selected customer. */
  groupsLoaded = true;
  readonly customerDropdownSelectLabel = CUSTOMER_DROPDOWN_SELECT_LABEL;
  /** Prevents header <-> column filter sync feedback loops. */
  private syncingHeaderColumnFilters = false;
  total_number_of_records = 0;
  isLoading = false; // Spinner state
  selectedDevices: any[] = [];
  selectedCheckboxDeviceId: number[] = [];
  public router=inject(Router)
  private readonly rbacService = inject(RbacService);
  private readonly unsavedHost = new UnsavedChangesHostHelper(
    inject(UnsavedChangesTrackerService),
    inject(MatDialog),
    inject(Router)
  );
  private fullColumnDefs: ColDef[] | null = null;
  readonly RbacPermissions = RbacPermissions;
  readonly overlayNoRowsTemplate = '<span class="device-list-no-rows">No Records Found</span>';
  defaultColDef: ColDef = {
    sortable: true,
    sortingOrder: ['asc', 'desc'],
    resizable: true,
    filter: 'agTextColumnFilter',
    floatingFilter: true,
    suppressHeaderMenuButton: true,
    suppressHeaderFilterButton: true,
  };

  /** Simple text floating filter — no advanced/funnel menu. */
  private readonly textFilterParams = {
    filterOptions: ['contains'],
    defaultOption: 'contains',
    trimInput: true,
    maxNumConditions: 1,
    suppressFilterButton: true,
  };

  /** UTC date filter with advanced operators — floating-filter funnel enabled. */
  private readonly dateColumnFilterParams = createUtcDateFilterParams();
  isDropdownOpen = false
  allSelected: boolean = false; // Toggle flag
  selectAllText: string = 'Select All in List'; // Add this property to hold the toggle text
  // Properties when we are navigating from Config List to Device List page
  groupNameFromConfigListPage: string = '';
  customerNameFromConfigListPage: string = '';
  configVersionFromConfigListPage:string = '';
  toggleValue: boolean = true;
  // Removed last edited highlight state

  // rowSelection: RowSelectionOptions | "single" | "multiple" = {
  //   mode: "multiRow",
  // };
  rowSelection: RowSelectionOptions | "single" | "multiple" = "multiple";

  selectedData:any;
  selectedCheckboxLength = new BehaviorSubject(0);
  dragSelectActive = false;
  dragMode: 'select' | 'deselect' | null = null;
  onRowSelected(event:any) {
    let selectedNodes = this.gridApi.getSelectedNodes();
    console.log('Row selected event - selected nodes:', selectedNodes.length);

    this.selectedData = selectedNodes.map((node: { data: any; }) => node.data);
    console.log('data',this.selectedData)

    this.selectedCheckboxDeviceId = this.selectedData
      .filter((item: any) => item && item.id)
      .map((item: any) => item.id);

    console.log('Selected IDs count:', this.selectedCheckboxDeviceId.length);
    this.deviceService.checkboxData.next(this.selectedCheckboxDeviceId.length===0?1:this.selectedCheckboxDeviceId.length);
    this.deviceService.deviceIds = this.selectedCheckboxDeviceId;

    // Count all loaded rows
    let loadedRowsCount = 0;
    this.gridApi.forEachNode((node: any) => {
      if (node && node.data) {
        loadedRowsCount++;
      }
    });

    console.log('Total loaded rows:', loadedRowsCount, 'Selected rows:', selectedNodes.length);

    // Update allSelected flag - true if all loaded rows are selected
    this.allSelected = loadedRowsCount > 0 && selectedNodes.length >= loadedRowsCount;

    // Update text based on selection state
    this.selectAllText = this.allSelected ? 'Unselect All' : 'Select All in List';
    console.log('Selection state updated:', this.allSelected, this.selectAllText);
  }
  onCellMouseDown(event: any) {
    if (event.colDef.field !== 'checkbox') return;
    const node = event.node;
    const wasSelected = node.isSelected();
    this.dragMode = wasSelected ? 'deselect' : 'select';
    this.dragSelectActive = true;
    node.setSelected(!wasSelected);
    if (event.event && typeof event.event.preventDefault === 'function') {
      event.event.preventDefault();
    }
  }

  // Removed highlight helpers (getRowStyle/getRowClass/getRowId)

  onCellMouseOver(event: any) {
    if (!this.dragSelectActive) return;
    if (event.colDef.field !== 'checkbox') return;
    const node = event.node;
    node.setSelected(this.dragMode === 'select');
  }

  // Removed modelUpdated handler for highlight

  @HostListener('document:mouseup')
  onGlobalMouseUp() {
    this.dragSelectActive = false;
    this.dragMode = null;
  }
  // Add defaultSortModel property
  // defaultSortModel = [
  //   { colId: 'customerName', sort: 'asc' }
  // ];

  // columnDefs Start for ag grid
  columnDefs: ColDef[] = [
    {
      headerName: '',
      field: 'checkbox',
      checkboxSelection: true,  // Checkbox for each row
      headerCheckboxSelection: true,  // Checkbox in the header
      sortable: false,
      filter: false,
      floatingFilter: false,
      width: 50
    },
      {
        headerName: 'Device Id',
        field: 'gatewayId',
        sortable: true,
        flex: 1,
        minWidth: 130,
        filter: 'agTextColumnFilter',
        filterParams: this.textFilterParams,
        suppressFloatingFilterButton: true,
        cellRenderer:(params:any)=>{
          const value = params?.value;
          if (value == null || String(value).trim() === '') {
            return 'N/A';
          }
          return `<span class="ag-grid-link">${value}</span>`;
        }
      },
      withDateColumnLayout({
        headerName: 'Last Seen (UTC)',
        field: 'lastSeen',
        sortable: true,
        flex: 1,
        filter: 'agDateColumnFilter',
        floatingFilter: true,
        filterParams: this.dateColumnFilterParams,
        cellRenderer: (params: any) => formatUtcDateTimeCell(params?.data?.lastSeen),
      }),

      withDateColumnLayout({
        headerName: 'Last Config (UTC)',
        field: 'lastConfigRequestTime',
        sortable: true,
        flex: 1,
        filter: 'agDateColumnFilter',
        floatingFilter: true,
        filterParams: this.dateColumnFilterParams,
        cellRenderer: (params: any) =>
          formatUtcDateTimeCell(params?.data?.lastConfigRequestTime),
      }),

      withDateColumnLayout({
        headerName: 'Last Wiliot (UTC)',
        field: 'tokenRequestTime',
        sortable: true,
        flex: 1,
        filter: 'agDateColumnFilter',
        floatingFilter: true,
        filterParams: this.dateColumnFilterParams,
        cellRenderer: (params: any) =>
          formatUtcDateTimeCell(params?.data?.tokenRequestTime),
      }),
      {
        headerName: 'Asset',
        field: 'assetName',
        sortable: true,
        flex: 1,
        minWidth: 130,
        filter: 'agTextColumnFilter',
        filterParams: this.textFilterParams,
        suppressFloatingFilterButton: true,
        cellRenderer: (params: any) => {
          return params?.data?.assetName ? params?.data?.assetName : "N/A";
        },
      },
      {
        headerName: 'Customer Name',
        field: 'customerName',
        sortable: true,
        flex: 1,
        minWidth: 140,
        filter: 'agTextColumnFilter',
        filterParams: this.textFilterParams,
        suppressFloatingFilterButton: true,
        cellRenderer: (params: any) => {
        const cName = params?.data?.customer?.customerName ;
        const cId = params?.data?.customer?.customerId;
        if (cName) {
          return `${cName} (${cId})`;
        }
        return "N/A";
      },
      },
      {
        headerName: 'Group',
        field: 'groupName',
        sortable: true,
        flex: 1,
        minWidth: 120,
        filter: 'agTextColumnFilter',
        filterParams: this.textFilterParams,
        suppressFloatingFilterButton: true,
        valueGetter: (params: any) => params.data?.otaGroup,
        cellRenderer: (params: any) => {
          const group = params.value;
          const gName = group?.groupName;
          const gId = group?.groupId;
          if (gName) {
            return `${gName} (${gId})`;
          }
          return "N/A";
        },
      },

      {
        headerName: 'Status',
        field: 'status',
        sortable: true,
        flex: 1,
        minWidth: 130,
        filter: 'agTextColumnFilter',
        filterParams: {
          filterOptions: ['contains'],
          defaultOption: 'contains',
          maxNumConditions: 1,
          suppressFilterButton: true,
        },
        suppressFloatingFilterButton: true,
        floatingFilterComponent: DeviceStatusFloatingFilter,
        cellRenderer: (params: any) => {
          return params?.data?.status ? params?.data?.status : "N/A";
        },
      },
      {
        headerName: 'Config',
        field: 'configVersion',
        sortable: true,
        flex: 1,
        minWidth: 110,
        filter: 'agTextColumnFilter',
        filterParams: this.textFilterParams,
        suppressFloatingFilterButton: true,
        cellRenderer: (params: any) => {
          return params?.data?.configVersion !== undefined && params?.data?.configVersion !== null
            ? params.data.configVersion.toString() : "N/A";
        }
      },
      {
        headerName: 'Firmware Version',
        field: 'currentFirmwareVersion',
        sortable: true,
        flex: 1,
        minWidth: 130,
        filter: 'agTextColumnFilter',
        filterParams: this.textFilterParams,
        suppressFloatingFilterButton: true,
        cellRenderer: (params: any) => {
          return params?.data?.currentFirmwareVersion !== undefined && params?.data?.currentFirmwareVersion !== null
            ? params.data.currentFirmwareVersion.toString() : "N/A";
        }
      },
      {
        headerName: 'Carrier Profile',
        field: 'carrierProfileName',
        sortable: true,
        flex: 1,
        minWidth: 130,
        filter: 'agTextColumnFilter',
        filterParams: this.textFilterParams,
        suppressFloatingFilterButton: true,
        cellRenderer:(params:any)=>{
          return params?.data?.carrierProfileName ? params?.data?.carrierProfileName : "N/A"
        }
      },
      withDateColumnLayout({
        headerName: 'Installed On (UTC)',
        field: 'installationDate',
        sortable: true,
        flex: 1,
        filter: 'agDateColumnFilter',
        floatingFilter: true,
        filterParams: this.dateColumnFilterParams,
        cellRenderer: (params: any) =>
          formatUtcDateTimeCell(params?.data?.installationDate),
      }),
      {
            headerName: 'Actions',
            field: 'actions',
            width: 100,
            sortable: false,
            filter: false,
            floatingFilter: false,
            cellRenderer: ButtonCellRendererDeviceListComponent,
            cellRendererParams: (params: any) => {
              return {
                rowData: params.data,
                selectedCheckboxDeviceId: this.selectedCheckboxDeviceId, // Pass selected IDs
                clicked: (data: any) => {
                }
              };
            }
          },
    ];



  // columnDefs End for ag grid

  private applyRbacToGrid(): void {
    if (!this.fullColumnDefs) {
      this.fullColumnDefs = [...this.columnDefs];
    }

    this.columnDefs = this.fullColumnDefs.filter((col) => {
      if (col.field === 'checkbox') {
        return this.rbacService.hasPermission(RbacPermissions.DeviceList_BulkEdit);
      }
      if (col.field === 'actions') {
        return this.rbacService.hasPermission(RbacPermissions.DeviceList_Edit_ActionCol);
      }
      return true;
    });

    const canBulkEdit = this.rbacService.hasPermission(
      RbacPermissions.DeviceList_BulkEdit
    );
    this.rowSelection = canBulkEdit ? 'multiple' : ('single' as const);

    if (this.gridApi) {
      this.gridApi.setGridOption('columnDefs', this.columnDefs);
      if (!canBulkEdit) {
        this.gridApi.deselectAll();
      }
    }
  }

  /* Start Copy Data cell Value function   */
    contextMenu: { visible: boolean; x: number; y: number } = {
      visible: false,
      x: 0,
      y: 0
    };
    selectedCellValue: string = '';
    contextMenuVisible: boolean = false;
    contextMenuPosition = { x: 0, y: 0 };

    getNestedProperty(obj: any, path: string): any {
      return get(obj, path, 'N/A'); // 'N/A' if value is undefined
    }
    onToggleTimeMode()
    {
      this.gridApi.refreshCells({ force: true });
    }

    onCellContextMenu(event: any) {
      event.event.preventDefault();
      const columnField = event.colDef.field;
      let cellValue = 'N/A';
      if (event.colDef.cellRenderer) {
        const cellRenderer = event.colDef.cellRenderer;
        const rendererParams = { data: event.data, colDef: event.colDef, value: event.value };
        const renderedValue = cellRenderer(rendererParams);
        if (typeof renderedValue === 'string') {
          cellValue = renderedValue.replace(/<[^>]*>/g, '');
        } else if (renderedValue?.outerText) {
          cellValue = renderedValue.outerText;
        }
      } else {
        cellValue = this.getNestedProperty(event.data, columnField);
      }

      // Check if the data and field are available
      if (event.node && event.node.data) {
        this.selectedCellValue = cellValue;
        this.contextMenuPosition = {
          x: event.event.clientX,
          y: event.event.clientY
        };
        this.contextMenuVisible = true;
      } else {
        this.contextMenuVisible = false;
      }
    }

    handleCopy() {
      navigator.clipboard.writeText(this.selectedCellValue)
      .then(() => {
        this.contextMenuVisible = false;
      })
      .catch(err => console.error('Failed to copy:', err));
    }

    // Hide context menu on outside click
    @HostListener('document:click')
    onDocumentClick(): void {
      this.contextMenuVisible = false;
    }
    preventDefaultContextMenu(event: MouseEvent): void {
      event.preventDefault();
    }
  /* End Copy Data cell Value function   */


  rowData: any[] = [];
  paginationPageSize = AG_GRID_DEFAULT_PAGE_SIZE;
  readonly pageSizeOptions = AG_GRID_PAGE_SIZE_OPTIONS;
  /** Host height from loaded rows — page scrolls, not the grid. */
  gridHostHeightPx = AG_GRID_HEADER_AND_PAGING_PX + AG_GRID_EMPTY_BODY_ROW_PX;
  /** Actual rows on the current page (drives height; not the page-size selector). */
  loadedRowCount = 0;
  gridApi: any;
  gridColumnApi: any;
  sortFlag: boolean = false;
  currentPage:any;
  configVersionFilterFromNavigation: string = '';
  constructor(
    private dialog: MatDialog,
    public dialogService: DialogService,
    public deviceService: DeviceService,
    private customerService: CustomerService,
    private route: ActivatedRoute,
    private toastr: ToastrService
  ) {}

  canDeactivate(): Promise<boolean> {
    return this.unsavedHost.canDeactivate();
  }

  @HostListener('window:beforeunload', ['$event'])
  onWindowBeforeUnload(event: BeforeUnloadEvent): void {
    this.unsavedHost.onBeforeUnload(event);
  }

  ngOnDestroy(): void {
    this.unsavedHost.clearOnDestroy();
  }

  ngOnInit(): void {
    this.rbacService.ensureContextLoaded().subscribe(() => this.applyRbacToGrid());

    const storedCustomer = sessionStorage.getItem('selectedCustomer');
    if (storedCustomer) {
      this.selectedCustomer = storedCustomer;
    }
    const storedGroup = sessionStorage.getItem('selectedGroup');
    if (storedGroup) {
      this.selectedGroup = storedGroup;
    }

    this.getAllCustomer$()
      .pipe(
        tap((res: any) => {
          this.customerList = res?.data?.content || [];
        }),
        concatMap(() => {
          if (this.selectedCustomer && this.selectedCustomer !== 'All') {
            const selectedCustomerObj = this.customerList.find(
              (obj: any) => obj.customerName === this.selectedCustomer
            );
            if (selectedCustomerObj?.id) {
              this.groupsLoaded = false;
              return this.deviceService.getOtagroupIdList(selectedCustomerObj.id);
            }
          }
          return of(null);
        })
      )
      .subscribe((response: any) => {
        if (response) {
          this.applyLoadedGroups(response.data?.content);
        } else {
          this.groupsLoaded = true;
        }
      });

    this.route.queryParams.subscribe(params => {
      if (params['configVersion']) {
        this.configVersionFilterFromNavigation = params['configVersion'];
        localStorage.setItem('configVer', this.configVersionFilterFromNavigation);
      }
    });

    //sorting
    const storedSorting = sessionStorage.getItem('deviceListSortingState');
    if (storedSorting) {
      const deviceListSortingState = JSON.parse(storedSorting);

      // Map colId to the correct field name for the API
      if (deviceListSortingState.colId === 'groupName') {
        this.deviceSearchPayload.sorts[0].field = 'otaGroup.groupName';
      } else if (deviceListSortingState.colId === 'customerName') {
        this.deviceSearchPayload.sorts[0].field = 'customer.customerName';
      } else if (deviceListSortingState.colId === 'currentFirmwareVersion') {
        this.deviceSearchPayload.sorts[0].field = 'currentFirmwareVersion';
      } else {
        this.deviceSearchPayload.sorts[0].field = deviceListSortingState.colId;
      }

      this.deviceSearchPayload.sorts[0].direction = deviceListSortingState.sort;
    }
  }
  ngAfterViewInit(): void {

  }
  onPaginationChanged(event: PaginationChangedEvent): void {
    syncInfiniteRowModelPageSize(
      event,
      this.paginationPageSize,
      (newPageSize) => {
        this.paginationPageSize = newPageSize;
        this.deviceSearchPayload.size = newPageSize;
        this.deviceSearchPayload.page = 0;
      }
    );

    this.currentPage = event.api.paginationGetCurrentPage();
    this.deviceSearchPayload.page = this.currentPage;
    event.api.deselectAll();
  }

downloadDevices() {
  this.isLoading = true;
  const body = {
    page: 0,
    size: this.total_number_of_records,
    filters: [{ field: '', operator: '', value: '' }],
    sorts: this.deviceSearchPayload.sorts,
    // sorts: [{ field: 'customer.customerName', direction: 'asc' }],
  };
  body.filters=this.deviceSearchPayload.filters;
  this.deviceService.getAllRecords(this.total_number_of_records,body)
    .subscribe({
      next: (data) => {
        const flattenedData = this.flattenData(data.data.content);
        const csvData = this.convertToCSV(flattenedData);
        // Trigger download
        this.downloadCSV(csvData, 'DeviceList.csv');
        this.isLoading = false
      },
      error: (error) => {
        this.isLoading = false
        console.error("Error while downloading data:", error);
      }
    });
}

formatDateSimple(dateStr: string): string {
  if (!dateStr) return '';
  return moment(dateStr).format('YYYY-MM-DD HH:mm:ss');
}

flattenData(data: any[]): any[] {
  return data.map(item => {
    const trhDevices = item.peripheralsTree?.filter((peripheral: any) => peripheral.type === 'TRH') || [];
    const bridgeDevices = item.peripheralsTree?.filter((peripheral: any) => peripheral.type === 'Wiliot Bridge') || [];
    const doorDevices = item.peripheralsTree?.filter((peripheral: any) => peripheral.type === 'Door Sensor') || [];
    const fuelDevices = item.peripheralsTree?.filter((peripheral: any) => peripheral.type === 'Fuel Sensor') || [];
    const cargoDevices = item.peripheralsTree?.filter((peripheral: any) => peripheral.type === 'Cargo Sensor') || [];

    // Format date fields with quotes to ensure they're treated as text in Excel
    const formatDateForExcel = (dateStr: string): string => {
      if (!dateStr) return '';
      try {
        // Parse the date string
        const parsedDate = moment(dateStr);
        if (parsedDate.isValid()) {
          // Format as YYYY-MM-DD HH:mm:ss and ensure it's treated as text in Excel by adding ="
          return `="${parsedDate.format('YYYY-MM-DD HH:mm:ss')}"`;
        } else {
          return '';
        }
      } catch (err) {
        return '';
      }
    };

    return {
      "Device Id": item.gatewayId,
      "Asset": item.assetName,
      "Customer Name": item.customer?.customerName || '',
      "Group": item.otaGroup?.groupName || '',
      "Status": item.status,
      "Config Version": (item.configVersion ?? "N/A").toString(),
      "Firmware Version": item.currentFirmwareVersion,
      "Carrier Profile": item.carrierProfileName,
      "Installed On (UTC)": formatDateForExcel(item.installationDate),
      "Last Seen (UTC)": formatDateForExcel(item.lastSeen),
      "Last Config (UTC)": formatDateForExcel(item.lastConfigRequestTime),
      "Last Wiliot (UTC)": formatDateForExcel(item.tokenRequestTime),
      // Extracting TRH macAddresses
      "TRH1": trhDevices[0]?.slots[0]?.macAddress || '',
      "TRH2": trhDevices[0]?.slots[1]?.macAddress || '',
      "TRH3": trhDevices[0]?.slots[2]?.macAddress || '',
      // Extracting Bridge macAddresses
      "Bridge1": bridgeDevices[0]?.slots[0]?.macAddress || '',
      "Bridge2": bridgeDevices[0]?.slots[1]?.macAddress || '',
      "Bridge3": bridgeDevices[0]?.slots[2]?.macAddress || '',
      // Extracting Door macAddresses
      "Door1": doorDevices[0]?.slots[0]?.macAddress || '',
      "Door2": doorDevices[0]?.slots[1]?.macAddress || '',
      "Door3": doorDevices[0]?.slots[2]?.macAddress || '',
      //Extracting Cargo
      "Cargo1": cargoDevices[0]?.slots[0]?.macAddress || '',
      "Cargo2": cargoDevices[0]?.slots[1]?.macAddress || '',
      "Cargo3": cargoDevices[0]?.slots[2]?.macAddress || '',
      // Extracting Fuel macAddresses
      "Fuel": fuelDevices[0]?.slots[0]?.macAddress || '',
    };
  });
}


// Helper function to convert JSON data to CSV format
convertToCSV(data: any[]): string {
  if (data.length === 0) return '';

  // Get headers from the first object
  const headers = Object.keys(data[0]);

  // Create CSV header row
  const headerRow = headers.join(',');

  // Create data rows
  const rows = data.map(row => {
    return headers.map(header => {
      let value = row[header];

      // Handle date fields that start with =" and end with "
      if (typeof value === 'string' && value.startsWith('="') && value.endsWith('"')) {
        // This is already a formatted date string, just return it as is
        return value;
      }

      // For all other values, escape quotes and wrap in quotes
      if (typeof value === 'string') {
        // Replace double quotes with two double quotes for CSV escaping
        value = value.replace(/"/g, '""');
      }

      // Wrap all values in quotes
      return `"${value}"`;
    }).join(',');
  });

  // Combine header and rows
  return [headerRow, ...rows].join('\r\n');
}

// Helper function to trigger CSV download
downloadCSV(csvData: string, filename: string) {
  const blob = new Blob([csvData], { type: 'text/csv;charset=utf-8;' });
  const link = document.createElement('a');

  if (link.download !== undefined) { // Feature detection
    const url = URL.createObjectURL(blob);
    link.setAttribute('href', url);
    link.setAttribute('download', filename);
    link.style.visibility = 'hidden';
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  }
}

  // downloadDevices() {
  //   const params = {
  //     fileName: 'devices_list.csv'
  //   };

  //   this.gridApi.exportDataAsCsv(params);

  // }

  // downloadDevices() {
  //   const params = {
  //     fileName: 'devices_list.csv',
  //     processCellCallback: (params : any) => {
  //       const field = params.column.getColId();
  //       const data = params.node.data;

  //       console.log('CHK', data);
  //       // Handle nested fields
  //       if (field === 'customerName') {
  //         return data.customer?.customerName || '';
  //       }
  //       if (field === 'otaGroup.groupName') {
  //         return data.otaGroup?.groupName || '';
  //       }
  //       if (field === 'product.manufacturer') {
  //         return data.product?.manufacturer || '';
  //       }

  //       // Default behavior for other fields
  //       return params.value;
  //     },
  //     processHeaderCallback: (params : any) => {
  //       const colId = params.column.getColId();

  //       // Rename headers for nested fields
  //       if (colId === 'customerName') return 'Customer Name';
  //       if (colId === 'otaGroup.groupName') return 'OTA Group Name';
  //       if (colId === 'product.manufacturer') return 'Manufacturer';

  //       return params.column.getColDef().headerName || colId;
  //     },
  //   };

  //   this.gridApi.exportDataAsCsv(params);
  // }


  deviceSearchPayload = {
    page: 0,
    size: AG_GRID_DEFAULT_PAGE_SIZE,
    filters: [
      {
        field: '',
        operator: '',
        value: '',
      },
    ],
    sorts: [
      {
        field: 'configVersion',
        direction: 'desc',
      },
      {
        field: 'id',
        direction: 'desc',
      }
    ],
  };

  sortForAgGrid(sortModel: any) {
    if (
      sortModel[0] == undefined ||
      sortModel[0] == null ||
      sortModel[0].colId == undefined ||
      sortModel[0].colId == null
    ) {
      return;
    }

    // Save sort state to session storage for persistence between page visits
    sessionStorage.setItem('deviceListSortingState', JSON.stringify(sortModel[0]));
    this.sortFlag = true;

    // Map column IDs to proper backend field names
    const colId = sortModel[0].colId;
    const sortDirection = sortModel[0].sort;

    // Handle special cases for field name mapping
    switch (colId) {
      case 'imei': {
        this.deviceSearchPayload.sorts[0].field = 'imei';
        this.deviceSearchPayload.sorts[0].direction = sortDirection;
        break;
      }
      case 'customerName': {
        this.deviceSearchPayload.sorts[0].field = 'customer.customerName';
        this.deviceSearchPayload.sorts[0].direction = sortDirection;
        break;
      }
      case 'groupName': {
        this.deviceSearchPayload.sorts[0].field = 'otaGroup.groupName';
        this.deviceSearchPayload.sorts[0].direction = sortDirection;
        break;
      }
      case 'status': {
        this.deviceSearchPayload.sorts[0].field = 'status';
        this.deviceSearchPayload.sorts[0].direction = sortDirection;
        break;
      }
      case 'assetName': {
        this.deviceSearchPayload.sorts[0].field = 'assetName';
        this.deviceSearchPayload.sorts[0].direction = sortDirection;
        break;
      }
      case 'installationDate': {
        this.deviceSearchPayload.sorts[0].field = 'installationDate';
        this.deviceSearchPayload.sorts[0].direction = sortDirection;
        break;
      }
      case 'carrierProfileName': {
        this.deviceSearchPayload.sorts[0].field = 'carrierProfileName';
        this.deviceSearchPayload.sorts[0].direction = sortDirection;
        break;
      }
      case 'configVersion': {
        this.deviceSearchPayload.sorts[0].field = 'configVersion';
        this.deviceSearchPayload.sorts[0].direction = sortDirection;
        break;
      }
      case 'currentFirmwareVersion': {
        this.deviceSearchPayload.sorts[0].field = 'currentFirmwareVersion';
        this.deviceSearchPayload.sorts[0].direction = sortDirection;
        break;
      }
      case 'gatewayId': {
        this.deviceSearchPayload.sorts[0].field = 'gatewayId';
        this.deviceSearchPayload.sorts[0].direction = sortDirection;
        break;
      }
      case 'lastSeen': {
        this.deviceSearchPayload.sorts[0].field = 'lastSeen';
        this.deviceSearchPayload.sorts[0].direction = sortDirection;
        break;
      }
      case 'lastConfigRequestTime': {
        this.deviceSearchPayload.sorts[0].field = 'lastConfigRequestTime';
        this.deviceSearchPayload.sorts[0].direction = sortDirection;
        break;
      }
      case 'tokenRequestTime': {
        this.deviceSearchPayload.sorts[0].field = 'tokenRequestTime';
        this.deviceSearchPayload.sorts[0].direction = sortDirection;
        break;
      }
      default: {
        // For any other columns, use the column ID as is
        this.deviceSearchPayload.sorts[0].field = colId;
        this.deviceSearchPayload.sorts[0].direction = sortDirection;
      }
    }
  }

  filterForAgGrid(filterModel: any) {
    let newFilters = [];

    if (filterModel && Object.keys(filterModel).length > 0) {
      Object.keys(filterModel).forEach((key) => {
        const filter = filterModel[key];
        if (!filter) {
          return;
        }

        // Status is an enum dropdown — always equals
        if (key === 'status') {
          const statusValue = filter['filter'];
          if (statusValue !== undefined && statusValue !== null && statusValue !== '') {
            newFilters.push({
              field: 'status',
              operator: 'equals',
              value: statusValue,
            });
          }
          return;
        }

        const apiField = this.mapDeviceListFilterField(key);
        const mapped = mapAgGridFilterToApi(apiField, filter);
        if (mapped) {
          newFilters.push(mapped);
        }
      });
    }

    // If no filters exist, add empty filter
    if (newFilters.length === 0) {
      newFilters.push({
        field: '',
        operator: '',
        value: '',
      });
    }

    this.deviceSearchPayload.filters = newFilters;
  }

  /** Map grid column ids to device-search API field paths. */
  private mapDeviceListFilterField(colId: string): string {
    switch (colId) {
      case 'customerName':
        return 'customer.customerName';
      case 'groupName':
        return 'otaGroup.groupName';
      default:
        return colId;
    }
  }

  customerSearchPayload = {
    page: 0,
    size: 500,
    filters: [{ field: '', operator: '', value: '' }],
    sorts: [{ field: 'customerName', direction: 'asc' }],
  };

  getAllCustomer$() {
    return this.customerService.getAllCustomer(this.customerSearchPayload);
  }

  get groupDropdownEmptyLabel(): string {
    return getGroupDropdownEmptyLabel(
      hasConcreteCustomerSelected(this.selectedCustomer),
      this.groups?.length ?? 0,
      this.groupsLoaded
    );
  }

  get isGroupDropdownDisabled(): boolean {
    return isGroupDropdownDisabled(
      hasConcreteCustomerSelected(this.selectedCustomer),
      this.groups?.length ?? 0,
      this.groupsLoaded
    );
  }

  private applyLoadedGroups(groups: any[] | null | undefined): void {
    this.groups = groups || [];
    this.groupsLoaded = true;
    if (this.groups.length === 0) {
      this.selectedGroup = '';
      sessionStorage.removeItem('selectedGroup');
    }
  }

  /** Header Customer dropdown → Customer Name column filter. */
  onHeaderCustomerChange(event: Event): void {
    const value = (event.target as HTMLSelectElement).value;
    this.selectedCustomer = value || 'All';
    sessionStorage.setItem('selectedCustomer', this.selectedCustomer);

    // Reset group whenever customer changes
    this.selectedGroup = '';
    this.groups = [];
    sessionStorage.removeItem('selectedGroup');

    if (this.selectedCustomer !== 'All') {
      this.groupsLoaded = false;
      const selectedCustomerObj = this.customerList.find(
        (obj: any) => obj.customerName === this.selectedCustomer
      );
      if (selectedCustomerObj?.id) {
        this.deviceService.getOtagroupIdList(selectedCustomerObj.id).subscribe((response: any) => {
          this.applyLoadedGroups(response?.data?.content);
        });
      } else {
        this.applyLoadedGroups([]);
      }
    } else {
      this.groupsLoaded = true;
    }

    this.applyHeaderFiltersToGridColumns({
      customerName: this.selectedCustomer === 'All' ? null : this.selectedCustomer,
      groupName: null,
    });
  }

  /** Header Group dropdown → Group column filter. */
  onHeaderGroupChange(event: Event): void {
    this.selectedGroup = (event.target as HTMLSelectElement).value || '';
    if (this.selectedGroup) {
      sessionStorage.setItem('selectedGroup', this.selectedGroup);
    } else {
      sessionStorage.removeItem('selectedGroup');
    }

    this.applyHeaderFiltersToGridColumns({
      groupName: this.selectedGroup || null,
    });
  }

  /**
   * Push header dropdown values into AG Grid column floating filters.
   * Infinite row model reloads via filterChanged / getRows.
   */
  private applyHeaderFiltersToGridColumns(updates: {
    customerName?: string | null;
    groupName?: string | null;
  }): void {
    if (!this.gridApi) {
      return;
    }

    const model: Record<string, any> = { ...(this.gridApi.getFilterModel() || {}) };
    const textContains = (value: string) => ({
      filterType: 'text',
      type: 'contains',
      filter: value,
    });

    if (updates.customerName !== undefined) {
      if (updates.customerName) {
        model['customerName'] = textContains(updates.customerName);
      } else {
        delete model['customerName'];
      }
    }

    if (updates.groupName !== undefined) {
      if (updates.groupName) {
        model['groupName'] = textContains(updates.groupName);
      } else {
        delete model['groupName'];
      }
    }

    this.syncingHeaderColumnFilters = true;
    this.deviceSearchPayload.page = 0;
    this.gridApi.setFilterModel(model);
    // Keep guard active until filterChanged handlers from setFilterModel finish.
    queueMicrotask(() => {
      this.syncingHeaderColumnFilters = false;
    });
  }

  /** Column floating filters → header Customer/Group dropdowns. */
  onGridFilterChanged(): void {
    if (!this.gridApi || this.syncingHeaderColumnFilters) {
      return;
    }

    const model = this.gridApi.getFilterModel() || {};
    const customerFilter = String(model['customerName']?.filter ?? '').trim();
    const groupFilter = String(model['groupName']?.filter ?? '').trim();

    if (!customerFilter) {
      if (this.selectedCustomer !== 'All') {
        this.selectedCustomer = 'All';
        sessionStorage.setItem('selectedCustomer', 'All');
        this.groups = [];
        this.selectedGroup = '';
        this.groupsLoaded = true;
        sessionStorage.removeItem('selectedGroup');
      }
    } else {
      const exactCustomer = this.customerList.find(
        (c: any) => c.customerName === customerFilter
      );
      if (exactCustomer) {
        if (this.selectedCustomer !== exactCustomer.customerName) {
          this.selectedCustomer = exactCustomer.customerName;
          sessionStorage.setItem('selectedCustomer', this.selectedCustomer);
          this.groupsLoaded = false;
          this.deviceService.getOtagroupIdList(exactCustomer.id).subscribe((response: any) => {
            this.applyLoadedGroups(response?.data?.content);
          });
        }
      }
      // Partial / free-text column filters keep the current dropdown selection.
    }

    if (!groupFilter) {
      if (this.selectedGroup) {
        this.selectedGroup = '';
        sessionStorage.removeItem('selectedGroup');
      }
    } else {
      const exactGroup = this.groups.find((g: any) => g.groupName === groupFilter);
      if (exactGroup && this.selectedGroup !== exactGroup.groupName) {
        this.selectedGroup = exactGroup.groupName;
        sessionStorage.setItem('selectedGroup', this.selectedGroup);
      } else if (!exactGroup && this.groups.length === 0 && this.selectedCustomer !== 'All') {
        // Groups may not be loaded yet; still reflect typed exact value if present in options later
        this.selectedGroup = groupFilter;
        sessionStorage.setItem('selectedGroup', this.selectedGroup);
      }
    }
  }

  dataSource = {
    getRows: (params: any) => {
      this.sortForAgGrid(params.sortModel);
      this.filterForAgGrid(params.filterModel);

      const pageSize = this.paginationPageSize || AG_GRID_DEFAULT_PAGE_SIZE;
      this.deviceSearchPayload.size = pageSize;

      // Preserve current page unless this is a new filter request
      const currentPage = this.currentPage || 0;

      // We need to preserve the selected page for pagination to work correctly
      if (this.deviceSearchPayload.page === undefined || params.startRow === 0) {
        this.deviceSearchPayload.page = 0;
      } else {
        this.deviceSearchPayload.page = currentPage;
      }

      // Use the deviceSearchPayload as the final payload
      const selectedPayload = {...this.deviceSearchPayload};

      this.deviceService.getAllDevices(selectedPayload).subscribe({
        next: (data) => {
          const { rows, sourceRowCount, reportedTotal } =
            this.normalizeDeviceListResponse(data);
          const lastRow = this.resolveDeviceInfiniteLastRow(
            params.startRow,
            rows.length,
            reportedTotal,
            sourceRowCount
          );
          this.rowData = rows;
          this.total_number_of_records =
            typeof lastRow === 'number' ? lastRow : reportedTotal;
          params.successCallback(rows, lastRow);
          this.syncGridHostHeight(rows.length);
          this.applyGridResultOverlay(rows.length, lastRow, params.startRow);
        },
        error: () => {
          this.syncGridHostHeight(0);
          params.failCallback();
          this.applyGridResultOverlay(0, 0, params.startRow);
        },
      });
    },
  };

  /**
   * Size host to the loaded page of rows (not page-size / 70vh).
   * Inline [style.height.px] on ag-grid-angular prevents global styles from winning.
   */
  private syncGridHostHeight(loadedRowCount: number): void {
    const rows = Number.isFinite(loadedRowCount) && loadedRowCount > 0 ? loadedRowCount : 0;
    this.loadedRowCount = rows;
    const bodyPx =
      rows > 0 ? rows * AG_GRID_DEFAULT_ROW_HEIGHT_PX : AG_GRID_EMPTY_BODY_ROW_PX;
    const contentPx = AG_GRID_HEADER_AND_PAGING_PX + bodyPx;
    const minHostPx = AG_GRID_HEADER_AND_PAGING_PX + AG_GRID_EMPTY_BODY_ROW_PX;
    this.gridHostHeightPx = Math.max(minHostPx, contentPx);
    this.cdr.detectChanges();
  }

  // Code for persisting the filter value

  // onFilterChanged() {
  //   const filterModel = this.gridApi.getFilterModel();
  //   console.log(JSON.stringify(filterModel))
  //   // ✅ Persist floating filters (Asset included)
  //   sessionStorage.setItem('deviceGridFilterModel', JSON.stringify(filterModel));

  //   // Reload grid
  //   this.gridApi.setGridOption('datasource', this.dataSource);
  // }
  onCellClicked(event: CellClickedEvent) {
    if (event.colDef.field === 'gatewayId') {
      this.deviceId = event?.data?.id;
      localStorage.setItem("deviceId",this.deviceId);
      localStorage.setItem("gatewayId",event?.data?.gatewayId);
      localStorage.setItem("gatewayIdDetails",event?.data?.gatewayId)
      // const dialogRef=this.dialog.open(DeviceDetailsComponent,{
      //   width:'75%',
      //   height:'70vh',
      //   panelClass: 'custom-dialog',
      //   disableClose: false
      // });
      this.router.navigate(['./device-details'])

      // setTimeout(() => {
      //   this.dialogService.getDeviceListRowData(this.rowEventData);
      // }, 0);

      //this.dialogService.setDialogRef(dialogRef);
    }
  }

  onGridReady(params: GridReadyEvent) {
    this.gridApi = params.api;
    // Code for persisting the filter value

    // const storedFilterModel = sessionStorage.getItem('deviceGridFilterModel');
    // if (storedFilterModel) {
    //   this.gridApi.setFilterModel(JSON.parse(storedFilterModel));
    // }
  // this.gridApi.setGridOption('datasource', this.dataSource);

    // Apply default sort
    const storedSorting = sessionStorage.getItem('deviceListSortingState');
    if (storedSorting) {
      const deviceListSortingState = JSON.parse(storedSorting);

      // Apply column state for visual sorting indicator
      this.gridApi.applyColumnState({
        state: [{ colId: deviceListSortingState.colId, sort: deviceListSortingState.sort }],
        applyOrder: false,
      });

      // Also ensure the correct field name is used in the payload
      if (deviceListSortingState.colId === 'groupName') {
        this.deviceSearchPayload.sorts[0].field = 'otaGroup.groupName';
      } else if (deviceListSortingState.colId === 'customerName') {
        this.deviceSearchPayload.sorts[0].field = 'customer.customerName';
      } else if (deviceListSortingState.colId === 'currentFirmwareVersion') {
        this.deviceSearchPayload.sorts[0].field = 'currentFirmwareVersion';
      } else {
        this.deviceSearchPayload.sorts[0].field = deviceListSortingState.colId;
      }
      this.deviceSearchPayload.sorts[0].direction = deviceListSortingState.sort;
    }

    // Store group and customer name from localStorage if present (config-list navigation)
    const groupName = localStorage.getItem('groupName');
    const customerName = localStorage.getItem('customerName');
    const configVersion = this.configVersionFilterFromNavigation || localStorage.getItem('configVer');
    if (configVersion) {
      this.configVersionFromConfigListPage = configVersion;
    }
    if (customerName) {
      this.customerNameFromConfigListPage = customerName;
    }
    if (groupName) {
      this.groupNameFromConfigListPage = groupName;
    }

    // Seed column filters from config-list navigation and header dropdowns
    const seedFilterModel: Record<string, unknown> = {
      ...(this.gridApi.getFilterModel() || {}),
    };
    const textContains = (value: string) => ({
      filterType: 'text',
      type: 'contains',
      filter: value,
    });

    if (customerName) {
      seedFilterModel['customerName'] = textContains(customerName);
      this.selectedCustomer = customerName;
      sessionStorage.setItem('selectedCustomer', customerName);
    } else if (this.selectedCustomer && this.selectedCustomer !== 'All') {
      seedFilterModel['customerName'] = textContains(this.selectedCustomer);
    }

    if (groupName) {
      seedFilterModel['groupName'] = textContains(groupName);
      this.selectedGroup = groupName;
      sessionStorage.setItem('selectedGroup', groupName);
    } else if (this.selectedGroup) {
      seedFilterModel['groupName'] = textContains(this.selectedGroup);
    }

    if (configVersion) {
      seedFilterModel['configVersion'] = textContains(configVersion);
    }

    const storedGatewayIdFilter = sessionStorage.getItem('gatewayIdFilter');
    if (storedGatewayIdFilter) {
      seedFilterModel['gatewayId'] = textContains(storedGatewayIdFilter.split(',')[0].trim());
    }

    const storedStatus = sessionStorage.getItem('selectedStatus');
    if (storedStatus && storedStatus !== 'All') {
      seedFilterModel['status'] = {
        filterType: 'text',
        type: 'equals',
        filter: storedStatus,
      };
    }

    if (Object.keys(seedFilterModel).length > 0) {
      this.syncingHeaderColumnFilters = true;
      this.gridApi.setFilterModel(seedFilterModel);
      this.syncingHeaderColumnFilters = false;
      localStorage.removeItem('groupName');
      localStorage.removeItem('customerName');
      localStorage.removeItem('configVer');
      sessionStorage.removeItem('gatewayIdFilter');
      sessionStorage.removeItem('selectedStatus');
      this.customerNameFromConfigListPage = '';
      this.groupNameFromConfigListPage = '';
      this.configVersionFromConfigListPage = '';
      this.configVersionFilterFromNavigation = '';
    }

    // Load groups for restored customer selection
    if (this.selectedCustomer && this.selectedCustomer !== 'All') {
      const selectedCustomerObj = this.customerList.find(
        (obj: any) => obj.customerName === this.selectedCustomer
      );
      if (selectedCustomerObj?.id) {
        this.groupsLoaded = false;
        this.deviceService.getOtagroupIdList(selectedCustomerObj.id).subscribe((response: any) => {
          this.applyLoadedGroups(response?.data?.content);
        });
      }
    }

    // Initialize the datasource after gridApi is available
    // This ensures the grid properly loads with all filters
    setTimeout(() => {
      this.deviceSearchPayload.page = 0;
      this.gridApi.purgeInfiniteCache();
      this.gridApi.setGridOption('datasource', this.dataSource);
    }, 0);
}

  // -----------



 // Toggle Select All
 onToggleSelectAll() {
  setTimeout(() => {
    // Log current selection state
    console.log('Current selection state:', this.allSelected);
    console.log('Selected rows:', this.gridApi.getSelectedNodes().length);

    // Toggle selection flag
    this.allSelected = !this.allSelected;

    // Count loaded rows (rows that have data loaded in the cache)
    let loadedRowsCount = 0;
    let processedNodes: any[] = [];

    // Process all nodes in the grid cache (not just visible ones)
    this.gridApi.forEachNode((node: any) => {
      // Only process nodes that have data (loaded rows)
      if (node && node.data) {
        loadedRowsCount++;
        node.setSelected(this.allSelected);
        processedNodes.push(node);
      }
    });

    console.log('Total loaded rows processed:', loadedRowsCount);

    // Update arrays after selection change
    const selectedNodes = this.gridApi.getSelectedNodes();
    console.log('Selected nodes after toggle:', selectedNodes.length);

    // Update selected data arrays
    this.selectedData = selectedNodes.map((node: any) => node.data);
    this.selectedCheckboxDeviceId = this.selectedData
      .filter((item: any) => item && item.id)
      .map((item: any) => item.id);

    this.deviceService.deviceIds = this.selectedCheckboxDeviceId;
    console.log('Selected IDs count:', this.selectedCheckboxDeviceId.length);

    // Update toggle text
    this.selectAllText = this.allSelected ? 'Unselect All' : 'Select All in List';
  }, 1000);
 }

  /** Drops placeholder/empty rows so zero-result searches show the no-rows overlay. */
  private isValidDeviceRow(row: unknown): boolean {
    if (!row || typeof row !== 'object') {
      return false;
    }

    const record = row as Record<string, unknown>;
    const gatewayId = this.normalizeDeviceIdentifier(record['gatewayId']);
    const deviceId = this.normalizeDeviceIdentifier(record['id']);

    return gatewayId.length > 0 || deviceId.length > 0;
  }

  private normalizeDeviceIdentifier(value: unknown): string {
    if (value == null) {
      return '';
    }
    const normalized = String(value).trim();
    if (!normalized) {
      return '';
    }
    const lowered = normalized.toLowerCase();
    if (lowered === 'n/a' || lowered === 'na' || lowered === 'undefined' || lowered === 'null') {
      return '';
    }
    return normalized;
  }

  private normalizeDeviceListResponse(data: {
    data?: { content?: unknown[]; totalElements?: number };
  }): { rows: unknown[]; sourceRowCount: number; reportedTotal: number } {
    const rawContent = Array.isArray(data?.data?.content) ? data.data.content : [];
    const rows = rawContent.filter((row) => this.isValidDeviceRow(row));
    const reportedTotal = Number(data?.data?.totalElements ?? 0);
    return {
      rows,
      sourceRowCount: rawContent.length,
      reportedTotal: Number.isFinite(reportedTotal) ? reportedTotal : 0,
    };
  }

  /**
   * Maps a server block to ag-Grid's lastRow after client-side row validation.
   * Do not pass through backend totalElements when invalid rows were removed.
   */
  private resolveDeviceInfiniteLastRow(
    startRow: number,
    rowCount: number,
    reportedTotal: number,
    sourceRowCount: number
  ): number | undefined {
    const pageSize = this.paginationPageSize;
    const filteredThisBlock = sourceRowCount > rowCount;
    const serverPageIsLast =
      sourceRowCount < pageSize ||
      (reportedTotal > 0 && startRow + sourceRowCount >= reportedTotal);

    if (!filteredThisBlock) {
      if (rowCount === 0) {
        return startRow;
      }
      if (serverPageIsLast || rowCount < pageSize) {
        return reportedTotal > 0
          ? Math.min(reportedTotal, startRow + rowCount)
          : startRow + rowCount;
      }
      return reportedTotal > 0 ? reportedTotal : undefined;
    }

    if (rowCount === 0) {
      return serverPageIsLast ? startRow : undefined;
    }
    if (rowCount < pageSize) {
      return serverPageIsLast ? startRow + rowCount : undefined;
    }
    return undefined;
  }

  /** Infinite row model does not auto-show the no-rows overlay — trigger it explicitly. */
  private applyGridResultOverlay(
    rowCount: number,
    lastRow: number | undefined,
    startRow: number
  ): void {
    if (!this.gridApi) {
      return;
    }

    const showEmpty =
      rowCount === 0 && (lastRow === 0 || (lastRow === startRow && startRow === 0));

    setTimeout(() => {
      if (!this.gridApi) {
        return;
      }
      if (showEmpty) {
        this.gridApi.showNoRowsOverlay();
        return;
      }
      if (rowCount > 0) {
        this.gridApi.hideOverlay();
      }
    });
  }

  onGo(): void {
    const selectedCount = this.selectedCheckboxDeviceId?.length || 0;
    if (selectedCount === 0) {
      this.toastr.warning('Please select at least one device to edit.', '', { timeOut: 2500 });
      return;
    }

    const rowDataForDialog = selectedCount === 1 ? this.selectedData?.[0] : (this.selectedData || []);

    const dialogRef = this.dialog.open(UpdateDeviceListComponent, {
      width: '90%',
      data: {
        rowData: rowDataForDialog,
        selectedIds: this.selectedCheckboxDeviceId
      },
      restoreFocus: false,
      closeOnNavigation: false,
    });

    dialogRef.afterClosed().subscribe(result => {
      document.body.removeAttribute('inert');
      // Completely refresh the grid data
      this.gridApi.setDatasource(this.dataSource);
      // Force a redraw of all cells
      this.gridApi.redrawRows();
      // Clear selections using forEachNode instead of deselectAll
      this.gridApi.forEachNode((node: any) => {
        node.setSelected(false);
      });
      // Reset selection variables
      this.selectedData = [];
      this.selectedCheckboxDeviceId = [];
      this.allSelected = false;
      this.selectAllText = 'Select All in List';
    });
  }

  // toggleDropdown(): void {
  //   this.isDropdownOpen = !this.isDropdownOpen
  // }

  // selectOption(option: string): void {
  //   this.editCustomer.emit(option)
  //   this.isDropdownOpen = false
  // }
}
